// Kept in sync with the currencyFormat in @/utils/helpers — renders an em-dash
// for absent values instead of "GHS NaN" while a fetch is still in flight.
export const currencyFormat = (value?: number | string | null) => {
  if (value === null || value === undefined || value === '') return '—';
  const amount = Number(value);
  if (!Number.isFinite(amount)) return '—';
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GHS',
    minimumFractionDigits: 2,
  }).format(amount);
};
